import React from 'react';

const UserContext = React.createContext({

    userId: null,
    userClaims: null,
    userName: null,
    userProvince:null,
    userMail: null,
    userToken: null,
    userPicture: null,
    userPhone: null,
    setSideNavValue: () => {},
    open: false,
    // setTokenUser: () => {},
    // userUnregistered: false,
    // userAuthenticated: false,
    userTest: null,
    isReady: false

});

export default UserContext;